<template>
    <v-container fluid class="secondary">
      <v-card elevation="11" class="primary pa-2" >
        <v-row class="justify-center align-center"><h2 class="textTitle--text">{{ $t('buyprod.screenTitle') }}</h2></v-row>
        <v-row class="justify-center align-center">
          <v-chip x-large label class="ma-2 pa-2 quinty"><h3 class="mr-3">{{ $t('addproduct.prodName') }}</h3><h3 class="primary--text">{{product.name}}</h3></v-chip>
          <v-chip x-large label class="ma-2 pa-2 quinty"><h3 class="mr-3">{{ $t('addproduct.prodCode') }}</h3><h3 class="primary--text">{{product.codigo}}</h3></v-chip>
          <v-chip x-large label class="ma-2 pa-2 quinty"><h3 class="mr-3">{{ $t('addproduct.inv') }}</h3><h3 class="primary--text">{{product.currenttInv}}</h3></v-chip>
        </v-row>
        <v-card elevation="11" class="ma-3 pa-3 secondary">
          <v-row >
            <v-col cols="6">
              <v-row class="justify-center align-center"><h2 class="mx-5 textMenu--text">{{ $t('buyprod.precioDeCompra', { '1': product.pu_buy }) }}</h2></v-row>
              
              
              <v-card class="secondary" v-if="product.price_mayor_buy.length" flat>
                <v-row v-for="precio in product.price_mayor_buy" :key="precio.id" class="ma-3 pa-1 justify-center align-center">
                  <h3 class="quinty--text">{{ $t('buyprod.qPor', { '1': precio.pu, '2': precio.qty, '3': precio.vendedor }) }}</h3>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-row class="align-center justify-center"><h2>{{ $t('qty')+' : ' }}</h2><v-text-field type="number" background-color="quinty" min="0" v-model.number="qtybuy" solo outlined class="ma-1 pa-1 shrink font-weight-black text-h6"></v-text-field></v-row>
              <v-row class="align-center justify-center"><h2>{{ $t('addproduct.prodPuBuy')+" : " }}</h2><v-text-field type="number" background-color="quinty" min="0" v-model.number="pu" solo outlined class="ma-1 pa-1 shrink font-weight-black text-h6"></v-text-field></v-row>
              <v-select v-model="fournisseur" :items="fournisseursDb" :item-text="'name'" :label="$t('addproduct.supplier')" class="ma-1 pa-1 font-weight-black black--text" solo >
                <template v-slot:append-outer>
                  <v-icon
                    @click="manageFournisseur"
                    color="textMenu"
                    large
                  >mdi-pencil</v-icon>
                  
                </template>
                </v-select>
                
                 
                
            </v-col>
          </v-row>
        </v-card>
        <v-row class="justify-center align-center">
                  <v-btn class="success mx-5 pa-2 font-weight-black black--text" @click="confirmBuy" >{{ $t('confirm') }}</v-btn>
                  
                  <h2 class="mr-3 textMenu--text">{{ $t('total')+" : " }}</h2>
                  <v-chip
                      large
                      class="mr-5 pa-5 font-weight-black text-h3"
                      color="orange lighten-3"
                    >
                      Q.{{this.qtybuy*this.pu}}
                    </v-chip>
                </v-row>
        
      </v-card>
   <v-dialog v-model="manageFournisseurDialog" width="80%" :retain-focus="false">
                      <manageFournisseur :key="buyForm" />
                    </v-dialog>

                    <v-dialog :retain-focus='false' width="550px" v-model="confirmProdDialog">
              <successMessage @close="confirmProdDialog=false" :title="'Confirmacion'" :message="$t('buyprod.confirmBuyMessage')" :key="errorKey"/>
            </v-dialog>

            <v-dialog :retain-focus='false' width="550px" v-model="errorProdQty">
              <errorMessage @close="errorProdQty=false" :title="'Error'" :message="$t('buyprod.errorProdQty')" :key="errorKey"/>
            </v-dialog>
</v-container>
</template>

<script>
  import manageFournisseur from "@/components/manageFournisseur"
  import errorMessage from '@/components/errorMessage'
  import successMessage from '@/components/successMessage'

export default {
    components:{manageFournisseur,errorMessage,successMessage},
      props:['product'],
    data () {
      return {
        qtybuy:0,
        pu:0,
        total:0,
        vendedor:0,
        
            fournisseur:'',
            manageFournisseurDialog:false,
            buyForm:0,
            confirmProdDialog:false,
            errorKey:0,
            errorProdQty:false,
      }
    },
    computed:{
      fournisseursDb(){
        var fournisseursDb=this.$store.state.fournDb
        return fournisseursDb
        }
    },
    methods: {
        manageFournisseur(){
          this.buyForm+=1;
          this.manageFournisseurDialog=true;
        },
        confirmBuy(){

          if(this.qtybuy==0){this.errorProdQty=true}else{

          var date = new Date();
            var buydb = this.$store.state.bills;
            var total=this.pu*this.qtybuy

            var id = 'compra1';      

            if(buydb.length>0){
               
            var size = buydb.length
            var pos=1

            for(var i=0;i<size;i++){
              if(buydb[i].id!=id){continue}else{
                pos+=1
                id='compra'+pos
                i=0
              }
            }
            }

            var compra={
              "id":id,
              "pu":this.pu,
              "qty":this.qtybuy,
              "vendedor":this.fournisseur,
              "total":total,
              "date":date,
              "prodid":this.product.id,
              "prodname":this.product.name
            }

            this.$store.dispatch('addBuy',compra)
                
              this.confirmProdDialog=true
          }
        }
    },
  }
</script>